import { __decorate, __metadata } from "tslib";
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
import { calculateTextColor, isValidColorValue, parseColorClasses } from '~/nasa_ui/utils/helpers/colors';
const DEFAULT_STARTING_POSITION = {
    x: '20px',
    y: '20px'
};
let AppPanel = class AppPanel extends Mixins(BaseVue) {
    hasEverCollapsed = false;
    isCollapsed = false;
    isDragging = false;
    isResizing = false;
    lastClosedPosition = { ...DEFAULT_STARTING_POSITION };
    lastOpenedPosition = { ...DEFAULT_STARTING_POSITION };
    positionOverride = null;
    borderColor;
    collapsible;
    startingPosition;
    maxWidth;
    get computedBorderColor() {
        if (!this.borderColor) {
            return '';
        }
        if (isValidColorValue(this.borderColor)) {
            return this.borderColor;
        }
        return parseColorClasses(this.borderColor);
    }
    get computedResizeHandleColor() {
        if (!this.computedBorderColor) {
            return 'var(--cosmic-text)';
        }
        if (isValidColorValue(this.computedBorderColor)) {
            return this.computedBorderColor;
        }
        return parseColorClasses(this.computedBorderColor);
    }
    get computedResizeHandleIconColor() {
        return calculateTextColor(this.computedResizeHandleColor);
    }
    onDrag(event) {
        this.isDragging = event.detail;
        this.$refs.app_panel?.bringToFront();
    }
    onPositionChanged(event) {
        if (this.isCollapsed) {
            const { x, y } = event.detail;
            this.lastClosedPosition = { x, y };
            return;
        }
        const { x, y } = event.detail;
        this.lastOpenedPosition = { x, y };
        // If the panel has never collapsed, we will update its last closed
        // position. That way when the first collapse happens it will collapse in
        // place. After the first collapse, we want to preserve the last closed
        // position so that the panel will always collapse to the same place instead
        // of following the dragged position.
        if (!this.hasEverCollapsed) {
            this.lastClosedPosition = { x, y };
        }
    }
    onResize(event) {
        this.isResizing = event.detail;
    }
    volleySmartPosition() {
        this.$nextTick(() => {
            const popover = this.$refs.app_panel;
            if (popover) {
                popover.smartPosition();
            }
        });
    }
    emitPanelClose() {
        this.$refs.app_panel.openOrCloseMenu(false);
    }
    onIsCollapsedChange(isCollapsed) {
        if (isCollapsed) {
            // Move the panel to the last closed position when collapsing
            this.positionOverride = { ...this.lastClosedPosition };
            this.hasEverCollapsed = true;
            return;
        }
        else {
            // If we are uncollapsing the panel, restore the last opened position
            this.$nextTick(() => {
                this.positionOverride = { ...this.lastOpenedPosition };
            });
        }
    }
    onStartingPositionChange(newPosition) {
        this.positionOverride = { ...newPosition };
    }
};
__decorate([
    Prop({
        type: String,
        default: 'var(--cosmic-gray-base)'
    }),
    __metadata("design:type", String)
], AppPanel.prototype, "borderColor", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppPanel.prototype, "collapsible", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => ({ ...DEFAULT_STARTING_POSITION })
    }),
    __metadata("design:type", Object)
], AppPanel.prototype, "startingPosition", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: '90vw'
    }),
    __metadata("design:type", String)
], AppPanel.prototype, "maxWidth", void 0);
__decorate([
    Emit('panel-close'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppPanel.prototype, "emitPanelClose", null);
__decorate([
    Watch('isCollapsed'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppPanel.prototype, "onIsCollapsedChange", null);
__decorate([
    Watch('startingPosition', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AppPanel.prototype, "onStartingPositionChange", null);
AppPanel = __decorate([
    Component
], AppPanel);
export default AppPanel;
